/* @flow */

import * as React from 'react';
import {connect} from 'react-redux';

import {InfoBanner} from 'shells/info-banner';
import {addJoyrideState} from '../onboarding/joyride';
import {ENTITY_FORM_INFOHEADER_TEXT} from '../onboarding/onboarding-constants';

const mapStateToProps = addJoyrideState(() => {});

type Props = {
    isJoyrideActive: boolean,
    isDemoSilo: boolean,
};

class JoyrideInfoBannerComponent extends React.PureComponent<Props> {
    render() {
        if (this.props.isJoyrideActive && this.props.isDemoSilo) {
            return <InfoBanner>{ENTITY_FORM_INFOHEADER_TEXT}</InfoBanner>;
        }

        return null;
    }
}

const connector = connect<Props, {||}, _, _, _, _>(mapStateToProps);
export const JoyrideInfoBanner = connector(JoyrideInfoBannerComponent);
